// import React, { useState } from "react";
// import Icon from "../assets/icons/Icon";
// import { posible_logo } from "./../config/imageImport";
// import { useSelector } from "react-redux";
// import { selectUser } from "../redux/slices/userSlice";
// import Button from "./controls/Button";
// import { useNavigate } from "react-router-dom";
// import CustomToast from "./controls/CustomToast";
// import PopupModal from "./controls/PopupModal";
// import Input from "./controls/Input";
// import { handleChangePassword } from "../api/UserApi";
// import { toast } from "react-toastify";
// import axios from "axios";

// const UserProfile = ({ onClose }) => {
//   const store = useSelector((state) => state.store.store);
//   const user = useSelector(selectUser);
//   const [showToast, setShowToast] = useState(false);
//   const [showChangePassword, setShowChangePassword] = useState(false);
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [confirmPasswordError, setConfirmPasswordError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const onChangePassword = async () => {
//     let employeePasswordError = "";
//     let employeeConfirmPasswordError = "";

//     if (password.trim() === "") {
//       employeePasswordError = "Please provide password";
//     }
//     if (confirmPassword.trim() === "") {
//       employeeConfirmPasswordError = "Please provide password";
//     }
//     if (password.length < 6) {
//       employeePasswordError =
//         "Password should be at least 6 characters in length";
//     }
//     if (
//       password.trim() !==
//       confirmPassword.trim()
//     ) {
//       employeeConfirmPasswordError =
//         "Password and confirm password do not match";
//     }

//     if (
//       employeePasswordError.trim() !== "" ||
//       employeeConfirmPasswordError.trim() !== ""
//     ) {
//       setPasswordError(employeePasswordError);
//       setConfirmPasswordError(employeeConfirmPasswordError);
//       return;
//     }
//     setLoading(true);
//     try {
//       const updatePasswordResponse = await handleChangePassword(user?.EmailID, password)
//       if (updatePasswordResponse.code == "0") {
//         toast.success("Password Updated Successfully !");
//       }
//       else {
//         toast.error(updatePasswordResponse?.message);
//       }
//     } catch (error) {
//       toast.error("Failed to update password");
//     }

//     const userID = user.key ? user.key : "";
//     // await this.updatePassword(userID,this.state.employeePassword);
//     const response = await axios.post(
//       "https://backend-o3dyulj4pa-el.a.run.app/v1/user/adduser",
//       {
//         userId: userID,
//         password: password,
//       }
//     );
//     if (response?.data?.message == "user added successfully") {
//       console.log("response", response);
//       toast.success("Password Changed Successfully");
//       setLoading(false);
//       onClose();
//     }
//     else {
//       toast.error("Failed to Changed Password");
//       setLoading(false);
//       onClose();
//     }
//   }

//   return (
//     <>
//       <div
//         className="fixed left-18 top-0 w-70 h-screen z-50 bg-[#0D111A] border-l border-gray-700 text-white overflow-y-auto custom-scrollable transition-all duration-300 ease-in-out"
//       >
//         {/* Full height flex container */}
//         <div className="flex flex-col justify-between h-full px-2 pb-4">

//           {/* Top section */}
//           <div className="grid gap-5">
//             {/* Logo and close icon */}
//             <div className="pt-4 w-full flex items-center">
//               {/* <img src={posible_logo} alt="" className="w-20 mr-auto" /> */}
//               <div
//                 className="w-7 flex items-center justify-center text-white/50 hover:text-white/80 cursor-pointer ml-auto"
//                 onClick={onClose}
//               >
//                 <Icon type="remove" />
//               </div>
//             </div>

//             {/* Store name and avatar */}
//             <div className="grid justify-center">
//               <div className="w-14 h-14 flex justify-center items-center text-2xl bg-[#EDE9FE] rounded-full capitalize mx-auto text-black">
//                 {store?.StoreName?.[0]}
//               </div>
//               <div className="text-white font-semibold mt-2 text-center">{store?.StoreName}</div>
//             </div>

//             {/* User info */}
//             <div className="flex space-x-2">
//               <span className="w-5"><Icon type={"user"} /></span><span>{user?.Name}</span>
//             </div>
//             <div className="flex space-x-2">
//               <span className="w-5"><Icon type={"email"} /></span><span>{user?.EmailID}</span>
//             </div>
//             {user?.Employee?.PhoneNo && (
//               <div className="flex space-x-2">
//                 <span className="w-5"><Icon type={"phone"} /></span><span>{user?.Employee?.PhoneNo}</span>
//               </div>
//             )}
//           </div>

//           {/* Bottom section */}
//           <div className="grid gap-2">
//             <span onClick={() => { setShowChangePassword(true) }} className="text-center cursor-pointer text-white/50 hover:text-white font-italic">
//               Change Password
//             </span>

//             <Button
//               type="primary"
//               onClick={() => setShowToast(true)}
//               iconType="signout"
//               showFullWidth={true}
//             >
//               Sign Out
//             </Button>
//           </div>
//         </div>

//         {/* Toast popup */}
//         {showToast && (
//           <CustomToast
//             type="warning"
//             message={"Are you sure want to sign out ?"}
//             primaryBtnText="Continue"
//             secondaryBtnText="Cancel"
//             onPrimaryClick={() => {
//               navigate("/");
//               setShowToast(false);
//             }}
//             onSecondaryClick={() => {
//               setShowToast(false);
//             }}
//             onClose={() => {
//               setShowToast(false);
//             }}
//           />
//         )}

//         {showChangePassword && <PopupModal
//           setPopUp={setShowChangePassword}
//           size="w-[300px] h-[250px]"
//           saveClick={() => { onChangePassword() }}
//           handleClose={() => { !loading && setShowChangePassword(false) }}
//           buttons={true}
//           secondbtnname={"Save"}
//           primaryBtnDisabled={loading}
//           secondaryBtnDisabled={loading}
//           title={"Change Password"}
//         >
//           <div className="grid gap-5">
//             <Input
//               value={password}
//               type={"password"}
//               placeholder={"password"}
//               onChange={(e) => { setPassword(e.target.value), setPasswordError("") }}
//               errorMessage={passwordError}
//             />
//             <Input
//               value={confirmPassword}
//               type={"password"}
//               placeholder={"password"}
//               onChange={(e) => { setConfirmPassword(e.target.value), setConfirmPasswordError("") }}
//               errorMessage={confirmPasswordError}
//             />

//           </div>

//         </PopupModal>}
//       </div>
//     </>
//   );
// };

// export default UserProfile;



import React, { useState } from "react";
import Icon from "../assets/icons/Icon";
import { useSelector } from "react-redux";
import { selectRegistration, selectUser } from "../redux/slices/userSlice";
import Button from "./controls/Button";
import { useNavigate } from "react-router-dom";
import CustomToast from "./controls/CustomToast";
import PopupModal from "./controls/PopupModal";
import Input from "./controls/Input";
import { handleChangePassword } from "../api/UserApi";
import { toast } from "react-toastify";
import axios from "axios";
import { version } from "../config/appVersion";
import IconButton from "./controls/IconButton";
import { deleteFcmTokenData, isMobileView } from "./controls/CommonFunctions";
import ChatWidget from "./controls/ChatWidget";
import { manualLogout } from "../util/localStorageUtils";

const UserProfile = ({ onClose }) => {
  const registration=useSelector(selectRegistration);
  const store = useSelector((state) => state.store.store);
    const isExpired = store?.NoOfDaysToExpire < 0 || false;
  const user = useSelector(selectUser);
  const [showToast, setShowToast] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

const stores =useSelector((state) => state.store.storesList);
      console.log("stores",stores);
  const onChangePassword = async () => {
    let employeePasswordError = "";
    let employeeConfirmPasswordError = "";

    if (password.trim() === "") {
      employeePasswordError = "Please provide password";
    }
    if (confirmPassword.trim() === "") {
      employeeConfirmPasswordError = "Please provide password";
    }
    if (password.length < 6) {
      employeePasswordError =
        "Password should be at least 6 characters in length";
    }
    if (
      password.trim() !==
      confirmPassword.trim()
    ) {
      employeeConfirmPasswordError =
        "Password and confirm password do not match";
    }

    if (
      employeePasswordError.trim() !== "" ||
      employeeConfirmPasswordError.trim() !== ""
    ) {
      setPasswordError(employeePasswordError);
      setConfirmPasswordError(employeeConfirmPasswordError);
      return;
    }
    setLoading(true);
    try {
      const updatePasswordResponse = await handleChangePassword(user?.EmailID, password)
      if (updatePasswordResponse.code == "0") {
        toast.success("Password Updated Successfully !");
      }
      else {
        toast.error(updatePasswordResponse?.message);
      }
    } catch (error) {
      toast.error("Failed to update password");
    }

    const userID = user.key ? user.key : "";
    // await this.updatePassword(userID,this.state.employeePassword);
    const response = await axios.post(
      "https://backend-o3dyulj4pa-el.a.run.app/v1/user/adduser",
      {
        userId: userID,
        password: password,
      }
    );
    if (response?.data?.message == "user added successfully") {
      console.log("response", response);
      toast.success("Password Changed Successfully");
      setLoading(false);
      onClose();
    }
    else {
      toast.error("Failed to Changed Password");
      setLoading(false);
      onClose();
    }
  }
  
  console.log("isMobileview",isMobileView());

  const onLogout=async()=>{
      setLoading(true);
    try{
    
       await deleteFcmTokenData();
       manualLogout();
           
            // navigate("/");
            setShowToast(false);
    }
    catch(error){
      console.log("error");
    }
    finally{
        setLoading(false);
    }
  }

  return (
    <div className={`fixed ${!isMobileView() ? "left-18 w-100" :"w-full" } top-0  h-screen z-50 bg-[#0D111A] border-l border-gray-700 text-white overflow-hidden flex flex-col`}
      // onMouseLeave={() => {
      //      onClose()
      // }}
    >
      {/* Close button */}
      {/* <div className="p-4 flex justify-end">
        <button onClick={onClose} className="text-gray-400 w-4 hover:text-white">
          <Icon type="remove" className="w-4 h-4" />
        </button>
      </div> */}
      <div className="absolute right-4 top-4 z-10">
    
         <div className="w-7 hover:scale-105 transition-transform duration-200 cursor-pointer"   onClick={onClose}>
              <Icon type="remove" />
            </div>
      </div>

      {/* PROFILE SECTION - TOP MOST */}
      <div className="pt-0 relative">
        <div className=" w-full h-56 primary-gradient"
          style={{
          //  background: 'linear-gradient(317deg, #5D8EF9 1.19%, #394A96 100%)'
          }}
        >
          {/* <div className="bg-blue-600 rounded-xl p-5 pb-6"> */}
           <div className="flex space-x-4 p-5 pt-9">
  {/* Avatar */}
  <div className="w-14 h-14 flex-shrink-0 flex justify-center items-center text-2xl bg-[#EDE9FE] rounded-lg capitalize text-black">
    {store?.StoreName?.[0]}
  </div>

  {/* Right Content */}
  <div className="min-w-0 flex-1">
    <span className="text-xl font-bold block break-words">
    {user?.Name}
    </span>
    <div>{user?.EmailID}</div>
    <p className="mt-1 flex items-center">
      <div className="w-5 mr-2 flex-shrink-0">
        <Icon type="store" />
      </div>
      <div className="truncate">{store?.StoreName}</div>
    </p>
      {/* {stores.length>1 && <div className="mt-3">
   <Button
          type="primary"
    onClick={() => {navigate("/store-selection", { replace: true })}}
          showFullWidth={false}
          className="flex-1 mr-2 text-xs py-1"
          iconType={"store"}
        >
          Change Store
        </Button>
    </div>} */}
  </div>
</div>
        </div>

        {/* ACCOUNT CARD - OVERLAPPING */}
        {/* <div className="absolute -bottom-4 left-6 right-6">
          <div className="bg-gray-800 rounded-lg p-4 shadow-lg border border-gray-700">
            <div className="flex space-x-3">
              <button
                onClick={() => setShowChangePassword(true)}
                className="flex-1 flex flex-col items-center p-2 hover:bg-gray-700 rounded"
              >
                <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mb-1">
                  <Icon type="lock" className="w-3 h-3 text-white" />
                </div>
                <span className="text-xs">Password</span>
              </button>
              <button className="flex-1 flex flex-col items-center p-2 hover:bg-gray-700 rounded">
                <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mb-1">
                  <Icon type="settings" className="w-3 h-3 text-white" />
                </div>
                <span className="text-xs">Settings</span>
              </button>
              <button className="flex-1 flex flex-col items-center p-2 hover:bg-gray-700 rounded">
                <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full flex items-center justify-center mb-1">
                  <Icon type="help" className="w-3 h-3 text-white" />
                </div>
                <span className="text-xs">Help</span>
              </button>
            </div>
          </div>
        </div> */}
          <div className="absolute -bottom-20 left-6 right-6">
          <div className="bg-gray-800 rounded-lg p-4 shadow-lg border border-gray-700">
              <div className="bg-gray-800 rounded-lg ">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium text-base">Subscription</h3>
            <span className="text-sm bg-blue-500 text-white px-2 py-1 rounded-lg ">
             {registration?.Plan}
            </span>
          </div>
             <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium text-base">Expire On</h3>
            <span className="text-sm bg-blue-500 text-white px-2 py-1 rounded-lg ">
              {store?.ExpiryDate
                      ? store.ExpiryDate
                      : store?.NoOfDaysToExpire + " Days"}
            </span>
          </div>
           
       
          <Button
            type="secondary"
            showFullWidth={true}
            onClick={()=>{toast.info("Link will be provided soon.")}}
            className="border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white text-xs py-1"
          >
            Renew
          </Button>
        </div>
          </div>
        </div>
      </div>

      {/* REST OF THE CARDS - BELOW OVERLAPPING CARD */}
      <div className="flex-1 overflow-y-auto px-6 py-6 space-y-4 mt-19">
        {/* Subscription Card */}
        {/* <div className="bg-gray-800 rounded-lg p-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium text-base">Subscription</h3>
            <span className="text-xs bg-blue-500 text-white px-2 py-1 rounded">
              Basic Plan
            </span>
          </div>
          <p className="text-gray-300 text-xs mb-3">
            Upgrade for premium features
          </p>
          <Button
            type="secondary"
            showFullWidth={true}
            className="border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white text-xs py-1"
          >
            Upgrade
          </Button>
        </div> */}

        {/* Support Card */}
       
        <div className="bg-gray-800 rounded-lg p-4">
          <h3 className="font-medium text-base">Support</h3>
          <div className="">
         <a 
  href="mailto:support@posible.in"
  className="w-full flex items-center p-2 hover:bg-gray-700 rounded no-underline text-white"
>
  <div className="w-4 h-4 mr-2 flex items-center justify-center">
    <Icon type="email" className="w-3 h-3" />
  </div>
  <span>support@posible.in</span>
</a>
              <button className="w-full flex items-center p-2 hover:bg-gray-700 rounded cursor-pointer" onClick={()=>{ window.open("https://posible.in/Help", '_blank')}}>
              <div className="w-4 h-4 mr-2 flex items-center justify-center">
                <Icon type="help" className="w-3 h-3" />
              </div>
              <span>Help Resources ?</span>
            </button>
            {/* <button className="w-full flex items-center p-2 hover:bg-gray-700 rounded text-sm">
              <div className="w-4 h-4 mr-2 flex items-center justify-center">
                <Icon type="phone" className="w-3 h-3 text-blue-400" />
              </div>
              <span>1800 102 9944</span>
            </button> */}
          </div>
        </div>

          {/* <div className="bg-gray-800 rounded-lg p-4">
          <h3 className="font-medium text-base">Download Posible App</h3>
          <div className="space-y-2 mt-2">
     <Button
 
  onClick={() => window.open("https://drive.google.com/uc?export=download&id=1TBSfYHHcWqF5GznzRKwy7mUarIGYo-KU", "_blank")}
 
  showFullWidth={true}
  type="primary"
  iconType="download"
>
  Download
</Button>


             <div className="text-gray-400 text-sm text-center">Version 1.1.22 • 125 MB</div>  
         
          </div>
        </div> */}
         
      </div>
     <div className="p-3 px-6 space-y-2 flex flex-col justify-between bg-[#0D111A]">
       {!isExpired && <Button
          type="secondary"
    onClick={() => setShowChangePassword(true)}
          showFullWidth={true}
          iconType={"edit"}
        >
          Change Password
        </Button>}
           {/* {!isExpired && <IconButton
     onClick={() => setShowChangePassword(true)}
      bgColor="#F5F5F5"
      textColor="#5e5e5e"
      newhover={true}
      infoText={"Change Password"}
      tooltipPosition={"right"}
      tooltipWidth={"200px"}
    >
      <Icon type="edit" />
    </IconButton>} */}
       {stores.length>1 && <Button
          type="secondary"
     onClick={() => {navigate("/store-selection", { replace: true })}}
          showFullWidth={true}
          iconType={"store"}
        >
          Change Store
        </Button>}
          {/* {stores.length>1 && 
           <IconButton
     onClick={() => {navigate("/store-selection", { replace: true })}}
      bgColor="#F5F5F5"
      textColor="#5e5e5e"
      newhover={true}
      infoText={"Change Store"}
      tooltipPosition={"top"}
      tooltipWidth={"110px"}
    >
      <Icon type="store" />
    </IconButton>} */}
          
  <Button
          type="secondary"
    onClick={() => setShowToast(true)}
          showFullWidth={true}
          iconType={"signout"}
        >
          Sign Out
        </Button>
             {/* <IconButton
  onClick={() => setShowToast(true)}
      bgColor="#F5F5F5"
      textColor="#5e5e5e"
      newhover={true}
      infoText={"Sign Out"}
      tooltipPosition={"top"}
      tooltipWidth={"110px"}
    >
      <Icon type="signout" />
    </IconButton> */}
        
        {/* <Button
          iconType={"signout"}
          type="primary"
          onClick={() => setShowToast(true)}
          showFullWidth={false}
          className="flex-1 ml-2 text-xs py-1"
        >
          Sign Out
        </Button> */}
      </div>
        <div className="flex border-t mt-auto border-gray-700 p-3 items-center justify-center mb-2 text-gray-400 text-sm">version: {version}</div> 
      {/* Fixed Footer */}
      

      {/* Modals (keep existing) */}
      {showToast && (
        <CustomToast
          loading={loading}
          type="warning"
          message={"Are you sure want to sign out ?"}
          primaryBtnText="Continue"
          secondaryBtnText="Cancel"
          onPrimaryClick={onLogout}
          onSecondaryClick={() => {
            setShowToast(false);
          }}
          onClose={() => {
            setShowToast(false);
          }}
        />
      )}

      {showChangePassword && (
        <PopupModal
          setPopUp={setShowChangePassword}
          size="w-[300px] h-[250px]"
          saveClick={onChangePassword}
          handleClose={() => !loading && setShowChangePassword(false)}
          buttons={true}
          secondbtnname={"Save"}
          primaryBtnDisabled={loading}
          secondaryBtnDisabled={loading}
          title={"Change Password"}
        >
          <div className="grid gap-5">
            <Input
              value={password}
              type={"password"}
              placeholder={"New password"}
              onChange={(e) => {
                setPassword(e.target.value), setPasswordError("");
              }}
              errorMessage={passwordError}
            />
            <Input
              value={confirmPassword}
              type={"password"}
              placeholder={"Confirm password"}
              onChange={(e) => {
                setConfirmPassword(e.target.value), setConfirmPasswordError("");
              }}
              errorMessage={confirmPasswordError}
            />
          </div>
        </PopupModal>
      )}
      {/* <ChatWidget enabled={true}/> */}
    </div>
  );

  // return (
  //   <div className="fixed  left-18 top-0 w-80 h-screen z-50 bg-[#0D111A] border-l border-gray-700 text-white overflow-hidden flex flex-col">
  //     {/* Header with close button */}
  //     <div className="p-4 flex justify-end">
  //       <button
  //         onClick={onClose}
  //         className="text-gray-400 hover:text-white transition-colors"
  //       >
  //         <Icon type="remove" />
  //       </button>
  //     </div>

  //     {/* Profile Section at the Top */}
  //     <div className="px-6 pt-2 pb-6">
  //       <div className="bg-gradient-to-r from-blue-600 to-blue-500 rounded-xl p-6 flex items-start space-x-4">
  //         <div className="w-20 h-20 flex justify-center items-center text-3xl bg-white rounded-full capitalize text-blue-600 font-bold">
  //           {user?.Name?.[0]}
  //         </div>
  //         <div className="flex-1">
  //           <div className="flex justify-between items-start">
  //             <div>
  //               <h2 className="text-2xl font-bold text-white">{user?.Name}</h2>
  //               <p className="text-blue-100 text-sm mt-1">{user?.EmailID}</p>
  //             </div>
  //             <div className="flex items-center space-x-1 bg-blue-700 px-2 py-1 rounded-full">
  //               <Icon type="verified" className="text-yellow-300 w-3 h-3" />
  //               <span className="text-xs text-white">Verified</span>
  //             </div>
  //           </div>

  //           <div className="mt-3 pt-3 border-t border-blue-400/30">
  //             <p className="text-blue-100 text-sm flex items-center">
  //               <Icon type="store" className="mr-2 w-4 h-4" />
  //               {store?.StoreName}
  //             </p>
  //             {user?.Employee?.PhoneNo && (
  //               <p className="text-blue-100 text-sm flex items-center mt-1">
  //                 <Icon type="phone" className="mr-2 w-4 h-4" />
  //                 {user?.Employee?.PhoneNo}
  //               </p>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //     {/* Scrollable Cards Section */}
  //     <div className="flex-1 overflow-y-auto px-6 pb-4 space-y-4">
  //       {/* Account Card */}
  //       <div className="bg-gray-800 rounded-xl p-4 shadow-lg">
  //         <h3 className="font-semibold text-lg mb-3">Account</h3>
  //         <div className="space-y-3">
  //           <button 
  //             onClick={() => setShowChangePassword(true)}
  //             className="w-full flex items-center justify-between p-3 hover:bg-gray-700 rounded-lg transition-colors"
  //           >
  //             <div className="flex items-center space-x-3">
  //               <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
  //                 <Icon type="lock" className="text-white w-4 h-4" />
  //               </div>
  //               <span>Change Password</span>
  //             </div>
  //             <Icon type="chevronRight" className="text-gray-400" />
  //           </button>
  //           <button className="w-full flex items-center justify-between p-3 hover:bg-gray-700 rounded-lg transition-colors">
  //             <div className="flex items-center space-x-3">
  //               <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
  //                 <Icon type="settings" className="text-white w-4 h-4" />
  //               </div>
  //               <span>Account Settings</span>
  //             </div>
  //             <Icon type="chevronRight" className="text-gray-400" />
  //           </button>
  //         </div>
  //       </div>

  //       {/* Subscription Card */}
  //       <div className="bg-gray-800 rounded-xl p-4 shadow-lg">
  //         <div className="flex justify-between items-center mb-3">
  //           <h3 className="font-semibold text-lg">Subscription</h3>
  //           <span className="text-xs bg-blue-500 text-white px-2 py-1 rounded-full">
  //             Basic Plan
  //           </span>
  //         </div>
  //         <p className="text-gray-300 text-sm mb-4">
  //           Upgrade to access premium features and analytics.
  //         </p>
  //         <Button
  //           type="secondary"
  //           showFullWidth={true}
  //           className="border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white"
  //         >
  //           Upgrade
  //         </Button>
  //       </div>

  //       {/* Support Card */}
  //       <div className="bg-gray-800 rounded-xl p-4 shadow-lg">
  //         <h3 className="font-semibold text-lg mb-3">Support</h3>
  //         <div className="space-y-3">
  //           <button className="w-full flex items-center space-x-3 p-3 hover:bg-gray-700 rounded-lg transition-colors">
  //             <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
  //               <Icon type="chat" className="text-white w-4 h-4" />
  //             </div>
  //             <span>Chat with Support</span>
  //           </button>
  //           <button className="w-full flex items-center space-x-3 p-3 hover:bg-gray-700 rounded-lg transition-colors">
  //             <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
  //               <Icon type="help" className="text-white w-4 h-4" />
  //             </div>
  //             <span>Help Center</span>
  //           </button>
  //           <button className="w-full flex items-center space-x-3 p-3 hover:bg-gray-700 rounded-lg transition-colors">
  //             <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
  //               <Icon type="phone" className="text-white w-4 h-4" />
  //             </div>
  //             <span>Call Support: 1800 102 9944</span>
  //           </button>
  //         </div>
  //       </div>
  //     </div>

  //     {/* Fixed Footer */}
  //     <div className="p-4 border-t border-gray-700 flex justify-between bg-[#0D111A]">
  //       <Button
  //         type="secondary"
  //         onClick={() => {}}
  //         showFullWidth={false}
  //         className="flex-1 mr-2"
  //       >
  //         My Profile
  //       </Button>
  //       <Button
  //         type="primary"
  //         onClick={() => setShowToast(true)}
  //         iconType="signout"
  //         showFullWidth={false}
  //         className="flex-1 ml-2"
  //       >
  //         Sign Out
  //       </Button>
  //     </div>

  //     {/* Modals (keep your existing modals) */}
  //     {showToast && (
  //       <CustomToast
  //         type="warning"
  //         message={"Are you sure want to sign out ?"}
  //         primaryBtnText="Continue"
  //         secondaryBtnText="Cancel"
  //         onPrimaryClick={() => {
  //           navigate("/");
  //           setShowToast(false);
  //         }}
  //         onSecondaryClick={() => {
  //           setShowToast(false);
  //         }}
  //         onClose={() => {
  //           setShowToast(false);
  //         }}
  //       />
  //     )}

  //     {showChangePassword && (
  //       <PopupModal
  //         setPopUp={setShowChangePassword}
  //         size="w-[300px] h-[250px]"
  //         saveClick={onChangePassword}
  //         handleClose={() => !loading && setShowChangePassword(false)}
  //         buttons={true}
  //         secondbtnname={"Save"}
  //         primaryBtnDisabled={loading}
  //         secondaryBtnDisabled={loading}
  //         title={"Change Password"}
  //       >
  //         <div className="grid gap-5">
  //           <Input
  //             value={password}
  //             type={"password"}
  //             placeholder={"New password"}
  //             onChange={(e) => {
  //               setPassword(e.target.value), setPasswordError("");
  //             }}
  //             errorMessage={passwordError}
  //           />
  //           <Input
  //             value={confirmPassword}
  //             type={"password"}
  //             placeholder={"Confirm password"}
  //             onChange={(e) => {
  //               setConfirmPassword(e.target.value), setConfirmPasswordError("");
  //             }}
  //             errorMessage={confirmPasswordError}
  //           />
  //         </div>
  //       </PopupModal>
  //     )}
  //   </div>
  // );
};

export default UserProfile;


